import {Component, OnDestroy, OnInit} from '@angular/core';
import {Layer, LayerLoadType} from '../types';
import {LayerService} from '../../../services/layer.service';


@Component({
    selector: 'layer-multi-load',
    template: `
    <app-collapse name="Options" [open]="false" *ngIf="layers.length > 0">
      <p>
        Certains calques sont trop lourds pour être chargés en temps réel (exp; Bâtiment, Routes, Surfaces en eau, Cours d'eau, Toponymes),
        Vous pouvez les charger de façon groupée en les sélectionnant ci-dessous, ou les charger manuellement un par un dans la liste des calques.
      </p>

      <div  class="text-center"  >
        <div>
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Calques</mat-label>
            <mat-select [(ngModel)]="layersToLoad" multiple>
              <mat-option *ngFor="let layer of layers" [value]="layer.id">{{layer.name}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <button class="pm-btn me-2" (click)="loadLayers()">
          <i class="bi bi-stack"></i> Charger les calques
        </button>
      </div>
    </app-collapse>
  `,
    standalone: false
})
export class LayerMultiLoadComponents implements OnInit, OnDestroy {

  constructor(
    private layerService: LayerService
  ) {}

  layers = [];
  layersToLoad = [];
  subscription: any;

  protected readonly LayerLoadType = LayerLoadType;

  ngOnInit(): void {
    this.subscription = this.layerService.layers$.subscribe(layers => {
      this.layers = layers.filter(layer => {
        return layer.loadType === LayerLoadType.Manual;
      });

      this.layersToLoad = this.layers
        .filter(layer => layer.id !== 'building')
        .map(layer => layer.id);
    });
  }

  loadLayers(): void {
    this.layersToLoad.forEach(layerId => {
      const layer = this.layers.find(l => l.id === layerId);
      if (layer) {
        layer.loadData(true);
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
